import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import Lenis from "lenis";
import Header from "@/components/Header";
import Footer from "@/components/Footer";
import WhatsAppLauncher from "@/components/WhatsAppLauncher";
import Home from "@/pages/Home";
import Services from "@/pages/Services";
import ServiceDetail from "@/pages/ServiceDetail";
import About from "@/pages/About";
import Faq from "@/pages/Faq";
import Contact from "@/pages/Contact";
import Blog from "@/pages/Blog";
import BlogPost from "@/pages/BlogPost";
import BlogDropshipping from "@/pages/BlogDropshipping";
import Legal from "@/pages/Legal";
import NotFound from "@/pages/NotFound";
import TeamInbox from "@/pages/TeamInbox";
import AdminLeads from "@/pages/AdminLeads";
import Landing from "@/pages/Landing";
import { initTracking, trackPageView } from "@/lib/tracking";

function Shell() {
  const location = useLocation();
  const isInbox = location.pathname === "/team-inbox";
  const isAdmin = isInbox || location.pathname === "/admin/leads";

  useEffect(() => {
    const lenis = new Lenis({ lerp: 0.11 });
    let raf;
    const loop = (t) => {
      lenis.raf(t);
      raf = requestAnimationFrame(loop);
    };
    raf = requestAnimationFrame(loop);
    initTracking();
    return () => {
      cancelAnimationFrame(raf);
      lenis.destroy();
    };
  }, []);

  useEffect(() => {
    trackPageView(location.pathname + location.search);
    if (location.hash) {
      const el = document.querySelector(location.hash);
      if (el) {
        setTimeout(() => el.scrollIntoView({ behavior: "smooth" }), 80);
        return;
      }
    }
    window.scrollTo(0, 0);
  }, [location.pathname, location.search, location.hash]);

  return (
    <div className="min-h-screen bg-paper">
      {!isAdmin && <Header />}
      <main>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/services" element={<Services />} />
          <Route path="/tiktok-shop-setup" element={<ServiceDetail slug="tiktok-shop-setup" />} />
          <Route path="/tiktok-shop-management" element={<ServiceDetail slug="tiktok-shop-management" />} />
          <Route path="/product-optimisation" element={<ServiceDetail slug="product-optimisation" />} />
          <Route path="/content-strategy" element={<ServiceDetail slug="content-strategy" />} />
          <Route path="/about" element={<About />} />
          <Route path="/faq" element={<Faq />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/blog" element={<Blog />} />
          <Route path="/blog/tiktok-shop-dropshipping-malaysia" element={<BlogDropshipping />} />
          <Route path="/blog/:slug" element={<BlogPost />} />
          <Route path="/privacy-policy" element={<Legal page="privacy" />} />
          <Route path="/terms" element={<Legal page="terms" />} />
          <Route path="/disclaimer" element={<Legal page="disclaimer" />} />
          <Route path="/team-inbox" element={<TeamInbox />} />
          <Route path="/admin/leads" element={<AdminLeads />} />
          <Route path="/lp/:slug" element={<Landing />} />
          <Route path="*" element={<NotFound />} />
        </Routes>
      </main>
      {!isAdmin && <Footer />}
      <WhatsAppLauncher />
    </div>
  );
}

function App() {
  return (
    <HelmetProvider>
      <BrowserRouter>
        <Shell />
      </BrowserRouter>
    </HelmetProvider>
  );
}

export default App;
